import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

export const config = defineConfig({
  theme: {
    tokens: {
      fonts: {
        body: { value: "Mulish Variable" },
        heading: { value: "Mulish Variable" },
      },
      colors: {
        blue: {
          50: {value: "#E9F3FC"},
          100: {value: "#C1DDF6"},
          200: {value: "#99C6F0"},
          300: {value: "#70B0EA"},
          400: {value: "#489AE5"},
          500: {value: "#2084DF"},
          600: {value: "#1A6AB2"},
          700: {value: "#134F86"},
          800: {value: "#0D3559"},
          900: {value: "#061A2D"},
        },
      }
    },
    semanticTokens: {
      colors: {
        fg: { DEFAULT: {value: "{colors.gray.700}"} },
        blue: {
          solid: { value: "{colors.blue.500}"}
        }
      }
    }
  },
});

export default createSystem(defaultConfig, config);
